import { Component, OnInit } from '@angular/core';
import { Angulartics2GoogleAnalytics } from 'angulartics2/ga';
import { Router, NavigationStart, NavigationEnd, Event } from '@angular/router';

import { environment } from 'src/environments/environment';

// tslint:disable-next-line: ban-types
declare let fbq: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  isOnline: boolean = true;

  constructor(
    private router: Router,
    angulartics2GoogleAnalytics: Angulartics2GoogleAnalytics) {
    if (environment.production) {
      // Google Tag Manager
      angulartics2GoogleAnalytics.startTracking();
      // Facebook Pixel
      this.router.events.subscribe((event: Event) => {
        if (event instanceof NavigationEnd) {
          // fbq('track', 'PageView');
        } else if (event instanceof NavigationStart) {
          // Every navigation sequence is given a unique ID. Even "popstate"
          // navigations are really just "roll forward" navigations that get
          // a new, unique ID.
          // console.log('NavigationStart Event :: Navigation ID:', event.id);
          // console.log('NavigationStart Event :: Navigation Route:', event.url);
          // console.log('NavigationStart Event :: Navigation Trigger:', event.navigationTrigger);
          // if (event.restoredState) {
          //  console.warn('NavigationStart Event :: Navigation Restoring ID:', event.restoredState.navigationId);
          // }
          // The "navigationTrigger" will be one of:
          // - imperative (ie, user clicked a link).
          // - popstate (ie, browser controlled change such as Back button).
          // - hashchange
          // NOTE: I am not sure what triggers the "hashchange" type.
          // This "restoredState" property is defined when the navigation
          // event is triggered by a "popstate" event (ex, back / forward
          // buttons). It will contain the ID of the earlier navigation event
          // to which the browser is returning.
          // CAUTION: This ID may not be part of the current page rendering.
          // This value is pulled out of the browser; and, may exist across
          // page refreshes.
          if (event.navigationTrigger === 'popstate') {
            // window.location.href = environment.parentAppBaseUrl;
            // return;
          }
        }
      });
    }
  }

  ngOnInit(): void {
    //It Will trigger every 3 seconds to check if user is online or not
    setInterval(() => {
      if (navigator.onLine) {
        this.isOnline = true;
      } else {
        this.isOnline = false;
      }
    }, 3000);
  }

}
